import React from "react";
import { BreadcrumbJsonLd } from "next-seo";
import Head from "next/head";

export default function JsonLdManager(props) {
  const pageKey = props.page;
  const breadCrumbConfig = props.breadCrumbConfig[pageKey];
  const homePageConfig = props.homeConfig;

  return (
    <>
      <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homePageConfig) }} />
      </Head>
      <BreadcrumbJsonLd itemListElements={breadCrumbConfig} />
    </>
  );
}
